export default {
  // 生产环境配置
  //   baseUrl: process.env.NODE_ENV == 'development' ? 'http://localhost:9555' : 'http://36.138.71.178:8555',
  // 测试环境配置
  // baseUrl: 'https://qcwlapi.zhidiansaas.com',
  //   baseUrl: 'https://api.v2.scqsng.org.cn',

  // 晴川未来
  // baseUrl: 'https://qcwlapi.zhidiansaas.com',

  // 四川省青少年宫
  baseUrl: 'https://api.v2.scqsng.org.cn',
  // baseUrl: 'https://testapi.v2.scqsng.org.cn',

  // 中江研学
  // baseUrl: 'https://zjapi.zhidiansaas.com',

  // 四川省青少年宫-测试环境
  // baseUrl: 'https://testapi.v2.scqsng.org.cn'
  // baseUrl: 'http://8.137.112.148:30071'

  // 启智方舟
  // baseUrl: 'https://qzfzapi.zhidiansaas.com'
  // baseUrl: 'http://192.168.101.55:20100'

  // 青神青少年宫
  // baseUrl: 'https://qsqsngapi.zhidiansaas.com'
  // baseUrl: 'http://192.168.101.55:30010'
  // baseUrl: 'https://qsqsngapi.zhidiansaas.com'
  // baseUrl: 'http://localhost:30010'

  // 开发环境
  // baseUrl: 'http://localhost:7555',
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js